<template>
  <div>
    <a-form layout="inline" class="mb-20">
      <a-form-item label="费用名称">
        <a-input v-model="dataForm.external_name" placeholder="费用名称搜索" />
      </a-form-item>
      <a-form-item>
        <a-button @click="getDataList" type="primary">查询</a-button>
      </a-form-item>
      <a-form-item v-permission="['admin:tripexternal:create']">
        <a-button @click="addOrUpdatePaymentHandle()" type="primary">新增</a-button>
      </a-form-item>
    </a-form>
    <a-table :scroll="{ x: 1200 }" :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
      :loading="dataListLoading" bordered>
      <template slot="footer" slot-scope="currentPageData">
        <a-statistic title="合计金额：" :value="totalMoney" />
        <!-- <h5>合计金额：{{ totalMoney }}</h5> -->
      </template>
      <template slot="process_status_text" slot-scope="process_status_text, row">
        <a-tag :color="row.process_status == 1 ? 'blue' : row.process_status == 2 ? 'green' : 'red'">{{
          process_status_text
        }}</a-tag>
      </template>
      <template slot="editBtn" slot-scope="text, row">
        <a class="btn-edit" @click="shoukuanshenhe([row.external_id])"
          v-permission="['admin:tripexternal:receivePaymentExamineResult']">
          费用核对
        </a>
        <a-button style="padding: 0 6px;color: red;" type="link" class="btn-edit" v-if="row.process_status == 3"
          @click="shoukuanshenheAgain(row.external_id)"
          v-permission="['admin:tripexternal:receivePaymentExamineResult']">
          重新核对
        </a-button>
        <a-button style="padding: 0 6px;" type="link" class="btn-edit"
          @click="addOrUpdatePaymentHandle(row.external_id)" v-permission="['admin:tripexternal:update']">
          编辑
        </a-button>
        <a-button style="padding: 0 6px;" type="link" class="btn-edit" @click="deleteHandle(row.external_id)"
          v-permission="['admin:tripexternal:delete']">
          删除
        </a-button>
      </template>
    </a-table>
    <!-- <a-pagination size="small" class="mr-20 float-right" :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" /> -->
    <shoukuan ref='shoukuan' @ok="ok"></shoukuan>
    <examine ref="examine" @ok="ok"></examine>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import shoukuan from "./shoukuan";
import examine from '../../views/financialDetails/examine.vue'
export default {
  mixins: [viewModule],
  components: {
    shoukuan,
    examine
  },
  props: ["trip_id", 'channel'],
  data() {
    return {
      dataForm: {
        trip_id: this.trip_id,
        channel: this.channel,
        external_name: null
      },
      columns: [
        {
          title: "费用名称",
          dataIndex: "external_name",
          width: 150,
          // customRender: (text) => text.substr(0, 11),
        },
        {
          title: "类型",
          dataIndex: "pay_type_text",
          width: 150,
        },
        {
          title: "账户",
          dataIndex: "account.account_name",
          width: 200,
        },
        {
          title: "金额",
          dataIndex: "external_total",
          width: 200,
        },
        {
          title: "交易时间",
          dataIndex: "external_receivetime",
          width: 200,
        },
        {
          title: "核对状态",
          dataIndex: "process_status_text",
          scopedSlots: { customRender: "process_status_text" },
          width: 200,
        },
        {
          title: "核对拒绝原因",
          dataIndex: "process_reason",
          width: 200,
        },
        {
          title: "操作",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/admin/tripexternal/page",
        deleteURL: "/admin/tripexternal/delete",
      },
      limit: 100,
      totalMoney: ""
    };
  },
  methods: {
    addOrUpdatePaymentHandle(external_id) {
      this.$refs.shoukuan.init({ external_id, trip_id: this.trip_id, channel: this.channel });
    },
    queryAfter(e) {
      this.totalMoney = e.data.totalMoney
    },
    ok() {
      this.getDataList()
      this.$emit('ok')
    },
    //费用核对
    shoukuanshenhe(external_id) {
      this.$refs.examine.init(external_id)
    },
    //重新核对
    shoukuanshenheAgain(external_id) {
      this.$confirm({
        title: '是否已修改完毕交易信息?',
        content: '确认后将再次提交给财务核对',
        onOk: () => {
          this.$http({
            url: '/admin/tripexternal/resetExamine',
            method: 'post',
            data: {
              external_id
            }
          }).then(() => {
            this.$message.success('重新发起核对成功')
            this.query()
          })
        },
      });
    },
  }
};
</script>

<style></style>